import { random } from 'lodash';
import Config from '../utils/Config.js';
import Utils from '../utils/Utils.js';
import SoundManager from '../utils/SoundManager.js';
import LocaleManager from '../utils/LocaleManager.js';
import StateButton from '../controls/StateButton.js';

export default class BigWinPopup extends Phaser.Group {

    constructor(game)
    {
        super(game);

        this.onClose = new Phaser.Signal();
        this.redraw();
        SoundManager.fadeOutMusic(100);
        SoundManager.playSound('sounds/win-extra', false, true);
    }

    redraw()
    {
        this.removeAll(true, true);
        const game = this.game;

        let bg = new Phaser.Image(game, 0, 0, 'popups.big-win.bg');

        let message = new Phaser.Text(game, bg.width >> 1, 0, LocaleManager.getString('popup_win_message'), {
            fill: '#E6B567',
            align: 'center',
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold',
            fontSize : Config.layout === Config.PORTRAIT ? 50 : 20
        });
        message.anchor.x = 0.5;
        this.addChild(message);

        let money = this._money = new Phaser.Text(game, bg.width >> 1, 0, '-', {
            fill: '#FFFFFF',
            align: 'center',
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold',
            fontSize : Config.layout === Config.PORTRAIT ? 80 : 40
        });
        money.anchor.x = 0.5;
        money.y = message.y + message.height - (Config.layout === Config.PORTRAIT ? 20 : 14);
        this.addChild(money);

        bg.y = money.y + money.height - (Config.layout === Config.PORTRAIT ? -4 : 4) - 15;
        this.addChild(bg);

        this.game.input.onUp.addOnce(this.close, this);

        let emitterPoints = {
            [Config.DESKTOP]: [
                { x: 70, y: 392 },
                { x: 190, y: 262 },
                { x: 340, y: 370 },
                { x: 516, y: 272 },
                { x: 635, y: 409 },
                { x: 674, y: 370 }
            ],

            [Config.LANDSCAPE]: [
                { x: 70, y: 369 },
                { x: 190, y: 237 },
                { x: 340, y: 348 },
                { x: 516, y: 246 },
                { x: 635, y: 383 },
                { x: 674, y: 344 }
            ],

            [Config.PORTRAIT]: [
                { x: 288, y: 292 },
                { x: 106, y: 421 },
                { x: 477, y: 415 },
                { x: 211, y: 612 },
                { x: 267, y: 584 },
                { x: 484, y: 545 }
            ]
        };

        if (this._emitters && this._emitters.length)
        {
            this._emitters.forEach((emitter, index) =>
            {
                emitter.position.set(
                    emitterPoints[Config.layout][index].x,
                    emitterPoints[Config.layout][index].y
                );
            });
        }
        else
        {
            this._emitters = emitterPoints[Config.layout].map((point) =>
            {
                let emitter = game.add.emitter(bg.x + point.x, bg.y + point.y, 1);
                emitter.gravity = 40;
                emitter.minParticleAlpha = 0.5;
                emitter.minParticleScale = 1.5;
                emitter.makeParticles(['popups.big-win.star']);
                return emitter;
            });
        }

        if (this._showArguments)
        {
            this._emitters.forEach((emitter, index) =>
            {
                emitter.position.set(
                    emitterPoints[Config.layout][index].x,
                    emitterPoints[Config.layout][index].y
                );
            });

            this.show.apply(this, this._showArguments);
        }
    }

    close()
    {
        SoundManager.playSound('sounds/touch');
        this.onClose.dispatch();
    }

    show(value = 0)
    {
        this._showArguments = arguments;

        this._money.text = Utils.formatMoney(0);
        this._emitters.forEach((emitter) =>
        {
            if (!emitter.parent)
            {
                return;
            }

            setTimeout(() =>
            {
                this.addChild(emitter);
                emitter.start(false, 5000, 2);
            }, random(500, 1500));
        });

        if (!this._moneyTween)
        {
            const tweenTarget = { money: 0 };
            const moneyTween = this._moneyTween = this.game.add.tween(tweenTarget);
            moneyTween.frameBased = true;
            moneyTween.onComplete.addOnce(() =>
            {
                this._money.text = Utils.formatMoney(value);
                this._moneyTween = null;
                setTimeout(() => this.onClose.dispatch(), 2000);
            });
            moneyTween.onUpdateCallback(() =>
            {
                this._money.text = Utils.formatMoney(tweenTarget.money);
            });
            moneyTween.to({ money: value }, 5000, Phaser.Easing.Exponential.InOut, true, 500);
        }
    }

    destroy()
    {
        SoundManager.removeByKey('sounds/win-extra');
        if (this._moneyTween)
        {
            this._moneyTween.stop();
            this._moneyTween = null;
        }

        this.game.input.onUp.remove(this.close, this);
        
        super.destroy();
    }

    alignToWorld(width, height)
    {
        if (Config.layout === Config.PORTRAIT)
        {
            this.position.set(
                (width - this.width >> 1) - this.getLocalBounds().x,
                (height - this.height >> 1) - 30
            );
        }
        else
        {
            this.position.set(
                (width - this.width >> 1) - this.getLocalBounds().x,
                10
            );
        }

    }
}